export const formatAuthStoreIdText = (
  authStoreId: number | null | undefined
): string => {
  if (authStoreId === null || authStoreId === undefined) {
    return '拠点ID: -';
  }
  return `拠点ID: ${authStoreId}`;
};
